import { App } from 'antd'

import { diskErrorText } from '../Helpers/diskErrors'
import { fileViewerStore } from '../Stores/FileViewerStore'

import type { DiskNode } from '../Contracts/DiskNode'

type FileRef = Pick<DiskNode, 'uuid' | 'updatedAt'>

/**
 * «Скачати» і «Відкрити в новій вкладці» за підписаним посиланням (кеш —
 * у `FileViewerStore`). Спільні для рядків диска й шапки переглядача.
 */
export const useDiskFileOpeners = () => {
    const { message } = App.useApp()

    const download = async (node: FileRef): Promise<void> => {
        try {
            const url = await fileViewerStore.contentUrl(node, 'attachment')

            // `attachment` не веде зі сторінки: браузер лише зберігає файл
            window.location.assign(url)
        } catch (error) {
            void message.error(diskErrorText(error, 'Не вдалося скачати файл'))
        }
    }

    /**
     * Вкладку відкриваємо одразу, у кліку, а адресу ставимо після запиту:
     * вікно, відкрите після `await`, браузер вважає спливним і блокує.
     */
    const openInNewTab = async (node: FileRef): Promise<void> => {
        const tab = window.open('about:blank', '_blank')

        try {
            const url = await fileViewerStore.contentUrl(node, 'inline')

            if (tab) {
                tab.opener = null
                tab.location.href = url
            } else {
                window.location.assign(url)
            }
        } catch (error) {
            tab?.close()
            void message.error(diskErrorText(error, 'Не вдалося відкрити файл'))
        }
    }

    return { download, openInNewTab }
}
